import cn from 'bem-cn';

import './ChallengeRequirementBadge.scss';

const b = cn('challenge-requirement-badge');

export const ChallengeRequirementBadge = () => {
    return <div className={b()}>Это важно</div>;
};
